
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#D6DBEA","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M46.5 39.391C46.5 47.46 40.008 54 32 54s-14.5-6.54-14.5-14.609C17.5 31.324 32 12 32 12s14.5 19.324 14.5 27.391z"}})])
          )
        }
      }
    